import UmlShapeWidgetBase from './UmlShapeWidgetBase';
import './UmlSeqLifelineWidget.css';

// Pure painter for UmlSeqLifelineShape — thin vertical dashed line under a
// participant. x/h are kept in sync by CsSeqDiaRelationHandler whenever the
// participant (x) or its bottom duplicate (h) moves — plain shape.x/y/w/h
// rendering, never independently draggable: a lifeline's own position is
// 100% derived from its participant, so it must not be detachable from it.
class UmlSeqLifelineWidget extends UmlShapeWidgetBase {
    getDisabledHandles() {
        return ['nw', 'ne', 'sw', 'se', 'n', 's', 'e', 'w'];
    }

    handleSelectOnly = (e) => {
        e.stopPropagation();
        this.props.onShapeSelected?.(this.props.shape.id);
    };

    render() {
        const shape = this.props.shape;
        return (
            <div
                className={`uml-seq-lifeline-widget${this.props.isSelected ? ' uml-selected' : ''}`}
                data-shape-id={shape.id}
                style={{ left: shape.x, top: shape.y, width: shape.w, height: shape.h, zIndex: this.props.stackIndex ?? shape.zIndex }}
                onMouseDown={this.handleSelectOnly}
            />
        );
    }
}

export default UmlSeqLifelineWidget;
